import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import './SingleProject.css';

function SingleProject({ id, name, desc, tags, demo, image }) {
    const isExternal = demo && demo.startsWith('http');
    const href = demo ? (isExternal ? demo : `/${demo}`) : '#';

    return (
        <a
            href={href}
            target={isExternal ? '_blank' : '_self'}
            rel="noopener noreferrer"
            className="sp-card"
        >
            <div className="sp-card__img-wrap">
                {image && <img src={image} alt={name} loading="lazy" />}
                <div className="sp-card__img-overlay" />
            </div>

            <div className="sp-card__body">
                <h3 className="sp-card__title">{name}</h3>
                {desc && <p className="sp-card__desc">{desc}</p>}

                <div className="sp-card__footer">
                    <span className="sp-card__arrow">
                        مشاهده <FaArrowLeft />
                    </span>
                </div>
            </div>
        </a>
    );
}

export default SingleProject;
